/**
 * Unambiguous (schema, name) round-trip key for blueprintDataTables.
 *
 * The previous `${schema}.${name}` encoding was ambiguous when either
 * field contained a literal '.' (a legal identifier in MSSQL / PG when
 * the name is quoted). JSON-encoding the tuple `[schema, name]` removes
 * all delimiter ambiguity at the cost of slightly longer keys.
 *
 * Both encode and decode must be inverse on all legal identifier
 * shapes — including ones containing '.', '"', '`', '\\', NULs, etc.
 */

export type TableId = { schema: string; name: string };

export function encodeTableKey(t: TableId): string {
  return JSON.stringify([t.schema, t.name]);
}

export function decodeTableKey(k: string): TableId {
  const arr = JSON.parse(k);
  if (
    !Array.isArray(arr) ||
    arr.length !== 2 ||
    typeof arr[0] !== 'string' ||
    typeof arr[1] !== 'string'
  ) {
    throw new Error(`Invalid table key: ${k}`);
  }
  return { schema: arr[0], name: arr[1] };
}
